import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import "../../../assets/css/general/Footer.css";

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Categories', path: '/categories' },
    { name: 'Shop', path: '/shops' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact Us', path: '/contact' }
  ];

  const aboutLinks = [
    { name: 'Our Story', path: '/about#story' },
    { name: 'Our Team', path: '/about#team' },
    { name: 'Our Values', path: '/about#values' },
    { name: 'Become a Seller', path: '/become-seller' }
  ];

  const customerLinks = [
    { name: 'My Account', path: '/account' },
    { name: 'Order History', path: '/orders' },
    { name: 'Wishlist', path: '/favorites' },
     { name: 'Help & Support', path: '/support' },
  ];

  const policyLinks = [
    { name: 'Privacy Policy', path: '/settings/privacy' },
    
  ];

  const socialLinks = [
    { icon: <FaFacebookF />, url: 'https://www.facebook.com/share/1DKPSpqVN2/', name: 'Facebook' },
    { icon: <FaInstagram />, url: 'https://www.instagram.com/crafthive__?igsh=MTVwOHd6ZTZqdncxOQ==', name: 'Instagram' },
    { icon: <FaTiktok />, url: 'https://www.tiktok.com', name: 'TikTok' }
  ];

  return (
    <footer className="footer">
      <Container>
        <Row className="footer-content">
          {/* Left Side - Brand Section */}
          <Col lg={4} md={12} className="footer-col-left">
            <div className="footer-brand">
              <h2 className="brand-name">CRAFTHIVE</h2>
              <p className="brand-tagline">
                Discover Unique Handmade Treasures Crafted with Love
              </p>
              
              {/* Social Icons */}
              <div className="media-icons">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                    aria-label={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </Col>

          {/* Quick Links */}
          <Col lg={2} md={3} sm={6} xs={6} className="footer-links-col">
            <div className="footer-section">
              <h3 className="footer-heading">QUICK LINKS</h3>
              <ul className="footer-links">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </Col>

          {/* About */}
          <Col lg={2} md={3} sm={6} xs={6} className="footer-links-col">
            <div className="footer-section">
              <h3 className="footer-heading">ABOUT</h3>
              <ul className="footer-links">
                {aboutLinks.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </Col>

          {/* Customer */}
          <Col lg={2} md={3} sm={6} xs={6} className="footer-links-col">
            <div className="footer-section">
              <h3 className="footer-heading">CUSTOMER</h3>
              <ul className="footer-links">
                {customerLinks.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </Col>

          {/* Policies */}
          <Col lg={2} md={3} sm={6} xs={6} className="footer-links-col">
            <div className="footer-section">
              <h3 className="footer-heading">POLICIES</h3>
              <ul className="footer-links">
                {policyLinks.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="copyright-text">
            © 2025 CRAFTHIVE. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;